exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border[data-v-789ad8a8]{border:1px solid rgba(0,0,0,.38);border-radius:8px;margin-bottom:1rem}.thumbnail-display[data-v-789ad8a8]{margin:auto;width:50%}.thumbnail[data-v-789ad8a8]{max-width:100%;max-height:100%}.other-images-display[data-v-789ad8a8]{display:flex;justify-content:center;align-items:center}.other-image[data-v-789ad8a8]{margin:1px;border:1px solid rgba(0,0,0,.38);max-width:calc(20% - 2px);max-height:calc(20% - 2px)}", ""]);

// exports
